import { Project } from '~screens/Dashboard/screens/Projects/types';
import api from '../config/api';

export interface Country {
    id: number;
    name: string;
    flag?: string;
}

export interface Route {
    id: number;
    name: string;
    description: string;
    countries: Country;
    countriesFormatted: string;
    kmz: string;
    totalInvestmentFormatted: string;
    actions: number;
    uuid: string;
    actionsList?: Project[];
    ajusteMapa?: {
        latitude: string,
        longitude: string,
        zoom: number
    } | null
}


export const getRoutes = () => api.get('/territories/all').then(response => {
    return response.data as Route[];
}); // eslint-disable-line camelcase

export const getRouteProjects = (routeId: number | string) => api.get(`/territories/${routeId}/actions/`).then(response => {
    return response.data as Route;
});